import { memo, useMemo } from 'react';

import Typography from 'components/UI/Typography/Typography';

import { RULES } from 'components/config/rewardSystem';

import styles from './BonusTasks.module.scss';

const BonusTasks = () => {
  const itemsJSX = useMemo(
    () =>
      RULES.bonusTasks.map(({ title, Icon }) => (
        <div key={title} className={styles.item}>
          <div className={styles.iconWrapper}>
            <Icon />
          </div>
          <Typography weight="semibold">{title}</Typography>
        </div>
      )),
    [],
  );

  return (
    <div className={styles.root}>
      <div className={styles.titleWrapper}>
        <div className={styles.iconWrapper}>
          <div className={styles.titleIcon}>🚀</div>
        </div>
        <Typography type="text-lg" weight="medium" uppercase>
          Bonus Tasks
        </Typography>
      </div>
      <div className={styles.descriptionWrapper}>
        <div>
          <Typography color="grey">
            At times, we’ll launch{' '}
            <Typography element="span" color="blue" weight="semibold">
              limited-time bonus missions.
            </Typography>
          </Typography>
          <Typography color="grey">
            Complete them to earn{' '}
            <Typography element="span" color="blue" weight="semibold">
              one-time mega rewards
            </Typography>{' '}
            and unlock powerful growth for your casino.
          </Typography>
        </div>
        <Typography color="grey">Sample tasks include:</Typography>
      </div>
      <div className={styles.items}>{itemsJSX}</div>
    </div>
  );
};

export default memo(BonusTasks);
